/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootBoxInstanceSource } from './LootBoxInstanceSource';
import {
    LootBoxInstanceSourceFromJSON,
    LootBoxInstanceSourceFromJSONTyped,
    LootBoxInstanceSourceToJSON,
    LootBoxInstanceSourceToJSONTyped,
} from './LootBoxInstanceSource';

/**
 * 
 * @export
 * @interface GrantLootBoxInstanceBody
 */
export interface GrantLootBoxInstanceBody {
    /**
     * 
     * @type {string}
     * @memberof GrantLootBoxInstanceBody
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof GrantLootBoxInstanceBody
     */
    lootBoxConfigId: string;
    /**
     * 
     * @type {LootBoxInstanceSource}
     * @memberof GrantLootBoxInstanceBody
     */
    source: LootBoxInstanceSource;
    /**
     * Optional reference ID (quest ID, competition ID, etc.)
     * @type {string}
     * @memberof GrantLootBoxInstanceBody
     */
    sourceRef?: string;
}



/**
 * Check if a given object implements the GrantLootBoxInstanceBody interface.
 */
export function instanceOfGrantLootBoxInstanceBody(value: object): value is GrantLootBoxInstanceBody {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('lootBoxConfigId' in value) || value['lootBoxConfigId'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function GrantLootBoxInstanceBodyFromJSON(json: any): GrantLootBoxInstanceBody {
    return GrantLootBoxInstanceBodyFromJSONTyped(json, false);
}

export function GrantLootBoxInstanceBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrantLootBoxInstanceBody {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'lootBoxConfigId': json['lootBoxConfigId'],
        'source': LootBoxInstanceSourceFromJSON(json['source']),
        'sourceRef': json['sourceRef'] == null ? undefined : json['sourceRef'],
    };
}

export function GrantLootBoxInstanceBodyToJSON(json: any): GrantLootBoxInstanceBody {
    return GrantLootBoxInstanceBodyToJSONTyped(json, false);
}

export function GrantLootBoxInstanceBodyToJSONTyped(value?: GrantLootBoxInstanceBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'lootBoxConfigId': value['lootBoxConfigId'],
        'source': LootBoxInstanceSourceToJSON(value['source']),
        'sourceRef': value['sourceRef'],
    };
}

